import { graphql } from "@opensea/graphql"
import { CancelOrderTableRowItem_orderFragment } from "../CancelOrderTableRowItem/CancelOrderTableRowItem.fragment"

export const CancelOrderTableRow_orderFragment = graphql(
  `
    fragment CancelOrderTableRow_order on Order {
      id
      pricePerItem {
        token {
          unit
          symbol
        }
        usd
      }
      quantity
      quantityRemaining
      side
      item {
        isFungible
      }
      ...CancelOrderTableRowItem_order
    }
  `,
  [CancelOrderTableRowItem_orderFragment],
)
